import React, {useState} from 'react'
import DepartmentDetailsForm from './DepartmentDetailsForm';
import DepartmentDetailsList from './DepartmentDetailsList';

const Department = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");


  return (
    <>
      {fromIsShown ? (
          <DepartmentDetailsForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <DepartmentDetailsList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
  
    </>
  )
}

export default Department
